import { parseCardMentions } from '../utils/cardMentions';

// Read-only inline renderer for a chat / logbook message body. Card
// mentions stored as `[Name](card:id)` become clickable gold pills
// (same .md-card-link style used in deck notes); everything else
// renders as plain text. The container should set whitespace-pre-wrap
// where multi-line wrapping matters.
//
// Props:
//   text. Message body (raw markdown-ish source)
//   onOpenCard. (cardId, event) => void; opens the card inspector
//   onCardHover. (cardId, element) => void; optional hover preview
//   onCardHoverEnd. () => void; optional
export default function CardMentionText({
  text,
  onOpenCard,
  onCardHover,
  onCardHoverEnd,
}) {
  const chunks = parseCardMentions(text);
  if (chunks.length === 0) return null;
  return (
    <>
      {chunks.map((chunk, i) => {
        if (chunk.type === 'text') return chunk.value;
        return (
          <span
            key={`card-${i}-${chunk.cardId}`}
            className="md-card-link"
            data-card-id={chunk.cardId}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onOpenCard?.(chunk.cardId, e);
            }}
            onMouseEnter={(e) => onCardHover?.(chunk.cardId, e.currentTarget)}
            onMouseLeave={() => onCardHoverEnd?.()}
          >
            {chunk.name}
          </span>
        );
      })}
    </>
  );
}
